import {createSlice, type SliceSelectors} from '@reduxjs/toolkit'

import {getInitialState} from '@web/slices/saleSettlement/slice'

import type {SaleSettlementReducers, MakeCreateSliceOptions} from './interfaces'
import type {SaleSettlementState} from '@web/slices/saleSettlement/slice'

export default (options?: MakeCreateSliceOptions) =>
    createSlice<SaleSettlementState, SaleSettlementReducers, 'saleSettlement', SliceSelectors<SaleSettlementState>>({
        name: 'saleSettlement',
        initialState: getInitialState(),
        reducers: {},
        extraReducers: (builder) => {
            options?.extraReducers?.(builder)
        },
    })
